import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../theme";
import { Icon } from "../icon";
export const InfoBar = ({ accent, icon, title }) => (_jsxs(Container, { className: accent, children: [_jsx(Icon, { name: icon, size: 24 }), _jsx(_Fragment, { children: title })] }));
const Container = styled.div `
  width: 100%;
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  animation: fade-in 0.5s ease-in both;
  font-size: ${({ theme }) => theme.fontSize[4]}px;

  .icon {
    margin-right: 8px;
  }

  &.success {
    color: ${({ theme }) => theme.color.textSuccess};
    background-color: ${({ theme }) => theme.color.fillSuccess}50;
  }

  &.info {
    color: ${({ theme }) => theme.color.textInfo};
    background-color: ${({ theme }) => theme.color.fillInfo}50;
  }
`;
